import { render, staticRenderFns } from "./category-list-group.vue?vue&type=template&id=72fef89c&"
import script from "./category-list-group.vue.ts?vue&type=script&lang=ts&"
export * from "./category-list-group.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports